import angular from 'angular';
import { heightCalcFactory } from './heightCalc.factory';

export const heightCalcModule = angular
  .module('bit.services.heightCalc', [])
  .factory('heightCalc', heightCalcFactory);
